import React from 'react';

function Icon({ children, size = 18, title }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : 'presentation'}
    >
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

export const IconPlus = (props) => (
  <Icon {...props}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </Icon>
);

export const IconSearch = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Icon>
);

export const IconPin = ({ filled, ...props }) => (
  <Icon {...props}>
    <circle cx="12" cy="6" r="4" fill={filled ? 'currentColor' : 'none'} />
    <path d="M12 10v12" />
  </Icon>
);

export const IconArrowRight = (props) => (
  <Icon {...props} size={16}>
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </Icon>
);

export const IconClose = (props) => (
  <Icon {...props} size={16}>
    <path d="M6 6l12 12" />
    <path d="M18 6L6 18" />
  </Icon>
);

export const IconCheck = (props) => (
  <Icon {...props} size={16}>
    <path d="M5 12.5l4.2 4.2L19 7.5" />
  </Icon>
);

export const IconAlert = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5" />
    <path d="M12 16h.01" />
  </Icon>
);

export const IconImage = (props) => (
  <Icon {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="8.5" cy="10" r="1.5" />
    <path d="m21 16-5.5-5.5L9 17" />
  </Icon>
);
